<template>
  <div class>
    <div class="home">
      <NavigationPath class="breadcrumb-mobile" />
      <div class="home__summary">
        <div class="home__summary__header">
          <p class="home__summary__header__title">Summary</p>
          <select
            name="store-dropdown"
            class="store-dropdown"
            @change="reportOrderSummary($event)"
          >
            <option :value="undefined" selected>All Stores</option>
            <option
              v-for="(store, index) in stores"
              :key="index"
              :value="store.id"
            >
              {{ store.id }} - {{ store.name }}
            </option>
          </select>
          <div class="home__summary__header__date-picker">
            <Datepicker
              placeholder="YYYY-MM-DD"
              v-model="summaryStartDate"
              @closed="reportOrderSummary"
              :disabled-dates="disabledDates"
              input-class="custom-date-input"
            ></Datepicker>
            <Datepicker
              placeholder="YYYY-MM-DD"
              v-model="summaryEndDate"
              @closed="reportOrderSummary"
              :disabled-dates="disabledDates"
              input-class="custom-date-input"
            ></Datepicker>
          </div>
        </div>
        <div class="home__summary__cards">
          <div class="home__summary__cards__card">
            <p class="home__summary__cards__card__title">Total Value</p>
            <p class="home__summary__cards__card__value">
              {{ (summary[0] ? summary[0].orderValue : 0) | formatMoney }}
            </p>
          </div>
          <div class="home__summary__cards__card">
            <p class="home__summary__cards__card__title">Number Of Orders</p>
            <p class="home__summary__cards__card__value">
              {{ summary[0] ? summary[0].orderCount : 0 }}
            </p>
          </div>
          <div class="home__summary__cards__card">
            <p class="home__summary__cards__card__title">Total Value Billed</p>
            <p class="home__summary__cards__card__value">
              {{ (summary[0] ? summary[0].billedOrderValue : 0) | formatMoney }}
            </p>
          </div>
          <div class="home__summary__cards__card">
            <p class="home__summary__cards__card__title">Orders Invoiced</p>
            <p class="home__summary__cards__card__value">
              {{ summary[0] ? summary[0].billedOrderCount : 0 }}
            </p>
          </div>
        </div>
      </div>
      <div class="home__daily-sales">
        <div class="home__daily-sales__header">
          <p class="home__daily-sales__header__title">Daily Sales</p>
          <select
            name="store-dropdown"
            class="store-dropdown"
            @change="reportOrderCount(showOrderCountGraph)"
            v-model="showOrderCountGraph"
          >
            <option :value="true">Order Count</option>
            <option :value="false">Order Value</option>
          </select>
          <select
            name="store-dropdown"
            class="store-dropdown"
            @change="reportOrderCount(true, $event)"
          >
            <option :value="undefined" selected>All Stores</option>
            <option
              v-for="(store, index) in stores"
              :key="index"
              :value="store.id"
            >
              {{ store.id }} - {{ store.name }}
            </option>
          </select>
          <div class="home__daily-sales__header__date-picker">
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="dailySalesStartDate"
              @closed="reportOrderCount"
              input-class="custom-date-input"
            ></Datepicker>
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="dailySalesEndDate"
              @closed="reportOrderCount"
              input-class="custom-date-input"
            ></Datepicker>
          </div>
          <a
            v-if="dailySalesData.length > 1"
            href="javascript:void(0)"
            @click="downloadDailySalesCSV"
            class="home__daily-sales__header__download-link"
            >Download Report</a
          >
        </div>
        <div class="home__daily-sales__graph">
          <GChart
            v-if="dailySalesData.length > 1"
            type="LineChart"
            :options="{ legend: { position: 'bottom' }, height: 350 }"
            :data="dailySalesData"
          />
          <p class="home__daily-sales__graph__message" v-else>
            No data available
          </p>
        </div>
      </div>
      <div class="home__top-seller">
        <div class="home__top-seller__header">
          <p class="home__top-seller__header__title">Top Seller</p>
          <select
            name="store-dropdown"
            class="store-dropdown"
            @change="reportProductsSellingTop($event)"
          >
            <option :value="undefined" selected>All Stores</option>
            <option
              v-for="(store, index) in stores"
              :key="index"
              :value="store.id"
            >
              {{ store.id }} - {{ store.name }}
            </option>
          </select>
          <div class="home__top-seller__header__date-picker">
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="topSellerStartDate"
              @closed="reportProductsSellingTop"
              input-class="custom-date-input"
            ></Datepicker>
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="topSellerEndDate"
              @closed="reportProductsSellingTop"
              input-class="custom-date-input"
              calendar-class="datepicker--open-right"
            ></Datepicker>
          </div>
        </div>
        <div
          class="home__top-seller__item-info"
          v-if="topSellerData.length > 0"
        >
          <div class="home__top-seller__item-info__features">
            <div class="home__top-seller__item-info__features__feature">
              <p class="home__top-seller__item-info__features__feature__title">
                Article Number
              </p>
              <p class="home__top-seller__item-info__features__feature__value">
                {{ topSellerData[0] ? topSellerData[0].articleNumber : 0 }}
              </p>
            </div>
            <div class="home__top-seller__item-info__features__feature">
              <p class="home__top-seller__item-info__features__feature__title">
                Brand Name
              </p>
              <p class="home__top-seller__item-info__features__feature__value">
                {{ topSellerData[0] ? topSellerData[0].brandName : "" }}
              </p>
            </div>
            <div class="home__top-seller__item-info__features__feature">
              <p class="home__top-seller__item-info__features__feature__title">
                Product Name
              </p>
              <p class="home__top-seller__item-info__features__feature__value">
                {{ topSellerData[0] ? topSellerData[0].productName : "" }}
              </p>
            </div>
            <div class="home__top-seller__item-info__features__feature">
              <p class="home__top-seller__item-info__features__feature__title">
                Total Sale
              </p>
              <p class="home__top-seller__item-info__features__feature__value">
                {{
                  (topSellerData[0] ? topSellerData[0].valueOrdered : 0)
                    | formatMoney
                }}
              </p>
            </div>
          </div>
          <img
            :src="topSellerData[0] ? topSellerData[0].image : '#'"
            :alt="
              topSellerData[0]
                ? topSellerData[0].productName
                : 'Product Image not available'
            "
            class="home__top-seller__item-info__image"
          />
        </div>
        <p class="home__top-seller__message" v-else>No data available</p>
      </div>
      <div class="home__top-categories">
        <div class="home__top-categories__header">
          <p class="home__top-categories__header__title">Top Categories</p>
          <select
            name="store-dropdown"
            class="store-dropdown"
            @change="reportCategorySellingTop($event)"
          >
            <option :value="undefined" selected>All Stores</option>
            <option
              v-for="(store, index) in stores"
              :key="index"
              :value="store.id"
            >
              {{ store.id }} - {{ store.name }}
            </option>
          </select>
          <div class="home__top-categories__header__date-picker">
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="topCategoriesStartDate"
              @closed="reportCategorySellingTop"
              input-class="custom-date-input"
            ></Datepicker>
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="topCategoriesEndDate"
              @closed="reportCategorySellingTop"
              input-class="custom-date-input"
            ></Datepicker>
          </div>
          <a
            v-if="topCategoriesData.length > 1"
            class="home__top-categories__header__download-link"
            href="javascript:void(0)"
            @click="downloadTopCategoriesCSV"
            >Download Report</a
          >
        </div>
        <div class="home__top-categories__graph">
          <GChart
            :options="columnChartOptions"
            type="ColumnChart"
            :data="topCategoriesData"
            v-if="topCategoriesData.length > 1"
          />
          <p class="home__top-categories__graph__message" v-else>
            No data available
          </p>
        </div>
      </div>
      <div class="home__top-sub-categories">
        <div class="home__top-sub-categories__header">
          <p class="home__top-sub-categories__header__title">
            Top Sub-Categories
          </p>
          <select
            name="store-dropdown"
            class="store-dropdown"
            @change="reportSubcategorySellingTop($event)"
          >
            <option :value="undefined" selected>All Stores</option>
            <option
              v-for="(store, index) in stores"
              :key="index"
              :value="store.id"
            >
              {{ store.id }} - {{ store.name }}
            </option>
          </select>
          <div class="home__top-sub-categories__header__date-picker">
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="topSubcategoriesStartDate"
              @closed="reportSubcategorySellingTop"
              input-class="custom-date-input"
            ></Datepicker>
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="topSubcategoriesEndDate"
              @closed="reportSubcategorySellingTop"
              input-class="custom-date-input"
              calendar-class="datepicker--open-right"
            ></Datepicker>
          </div>
          <a
            v-if="topSubcategoriesData.length > 1"
            class="home__top-sub-categories__header__download-link"
            href="javascript:void(0)"
            @click="downloadTopSubcategoriesCSV"
            >Download Report</a
          >
        </div>
        <div class="home__top-sub-categories__graph">
          <GChart
            type="PieChart"
            :data="topSubcategoriesData"
            :options="pieChartOptions"
            v-if="topSubcategoriesData.length > 1"
          />
          <p class="home__top-sub-categories__graph__message" v-else>
            No data available
          </p>
          <div class="home__top-sub-categories__graph__values">
            <p
              class="home__top-sub-categories__graph__values__value"
              v-for="(subcategory, index) in topSubcategoriesData"
              :key="index"
            >
              <template v-if="index !== 0"
                >{{
                  (
                    (subcategory[1] / topSubCategoriesTotalOrderCount) *
                    100
                  ).toFixed(1)
                }}%&nbsp; {{ subcategory[0] }}</template
              >
            </p>
          </div>
        </div>
      </div>
      <div class="home__top-brands">
        <div class="home__top-brands__header">
          <p class="home__top-brands__header__title">Top Brands</p>
          <select
            name="store-dropdown"
            class="store-dropdown"
            @change="reportBrandSellingTop($event)"
          >
            <option :value="undefined" selected>All Stores</option>
            <option
              v-for="(store, index) in stores"
              :key="index"
              :value="store.id"
            >
              {{ store.id }} - {{ store.name }}
            </option>
          </select>
          <div class="home__top-brands__header__date-picker">
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="topBrandsStartDate"
              @closed="reportBrandSellingTop"
              input-class="custom-date-input"
            ></Datepicker>
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="topBrandsEndDate"
              @closed="reportBrandSellingTop"
              input-class="custom-date-input"
            ></Datepicker>
          </div>
          <a
            v-if="topBrandsData.length > 1"
            class="home__top-brands__header__download-link"
            href="javascript:void(0)"
            @click="downloadTopBrandsCSV"
            >Download Report</a
          >
        </div>
        <div class="home__top-brands__graph">
          <GChart
            type="BarChart"
            :options="{ legend: 'none', fontSize: 10 }"
            :data="topBrandsData"
            v-if="topBrandsData.length > 1"
          />
          <p class="home__top-brands__graph__message" v-else>
            No data available
          </p>
        </div>
      </div>
      <div class="home__sales-overview">
        <div class="home__sales-overview__header">
          <p class="home__sales-overview__header__title">Sales Overview</p>
          <select
            name="store-dropdown"
            class="store-dropdown"
            @change="reportCityTop($event)"
          >
            <option :value="undefined" selected>All Stores</option>
            <option
              v-for="(store, index) in stores"
              :key="index"
              :value="store.id"
            >
              {{ store.id }} - {{ store.name }}
            </option>
          </select>
          <div class="home__sales-overview__header__date-picker">
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="salesOverviewStartDate"
              @closed="reportCityTop"
              input-class="custom-date-input"
            ></Datepicker>
            <Datepicker
              placeholder="YYYY-MM-DD"
              :disabled-dates="disabledDates"
              v-model="salesOverviewEndDate"
              @closed="reportCityTop"
              input-class="custom-date-input"
              calendar-class="datepicker--open-right"
            ></Datepicker>
          </div>
          <a
            v-if="cityData.length > 1"
            class="home__sales-overview__header__download-link"
            href="javascript:void(0)"
            @click="downloadSalesOverviewCSV"
            >Download Report</a
          >
        </div>
        <div class="home__sales-overview__graph">
          <div class="home__sales-overview__graph__map">
            <GChart
              type="GeoChart"
              :data="cityData"
              :settings="{
                packages: ['geochart'],
                mapsApiKey: 'AIzaSyBYgsm5mnuLCIOWlFTswtfbqkOolDsFXbI'
              }"
              :options="cityMapOptions"
              v-if="cityData.length > 1"
            />
            <p class="home__sales-overview__graph__message" v-else>
              No data available
            </p>
          </div>
          <div class="home__sales-overview__graph--hide-xs">
            <GChart
              type="BarChart"
              :data="cityData"
              v-if="cityData.length > 1"
            />
            <p class="home__sales-overview__graph__message" v-else>
              No data available
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GChart } from "vue-google-charts";
import NavigationPath from "@/components/Navigation/NavigationTop/NavigationPath";
import Datepicker from "vuejs-datepicker";

export default {
  name: "Home",
  components: {
    GChart,
    NavigationPath,
    Datepicker
  },
  mounted() {
    const inputs = document.querySelectorAll(" .form-control");
    for (const input of inputs) {
      input.addEventListener("keypress", function(event) {
        event.preventDefault();
      });
    }
    this.$store
      .dispatch("fetchAllStores")
      .then(result => {
        this.stores = result;
        this.allStoresArray = result.map(store => store.id);
        this.summaryStore = this.allStoresArray;
        this.salesOverviewStore = this.allStoresArray;
        this.topSellerStore = this.allStoresArray;
        this.topCategoriesStore = this.allStoresArray;
        this.topSubcategoriesStore = this.allStoresArray;
        this.topBrandsStore = this.allStoresArray;
        this.dailySalesStore = this.allStoresArray;
        this.reportOrderSummary();
        this.reportCityTop();
        this.reportOrderCount();
        this.reportProductsSellingTop();
        this.reportCategorySellingTop();
        this.reportSubcategorySellingTop();
        this.reportBrandSellingTop();
      })
      .catch(err => {
        if (err.status != 401) {
          this.error = err.data;
        } else {
          this.$router.push({ name: "Login" }).catch(() => {});
        }
      });
  },
  data() {
    return {
      summary: [],
      topSellerData: [],
      topCategoriesData: [],
      topBrandsData: [],
      topSubcategoriesData: [],
      cityData: [],
      cityMapOptions: {
        region: "IN",
        colorAxis: { colors: ["#e7711c", "#4374e0"] },
        datalessRegionColor: "transparent",
        displayMode: "markers",
        domain: "IN",
        resolution: "provinces",
        width: window.screen.width < 500 ? window.screen.width - 50 : 500
      },
      pieChartOptions: {
        slices: {
          1: { offset: 0.2 },
          3: { offset: 0.3 },
          5: { offset: 0.4 },
          7: { offset: 0.3 },
          9: { offset: 0.2 }
        },
        legend: { position: "bottom", alignment: "start" },
        pieHole: 0.4,
        width: window.screen.width < 450 ? window.screen.width - 50 : 350,
        height: 350
      },
      columnChartOptions: {
        bar: { groupWidth: 25 },
        legend: { position: "none" }
      },
      dailySalesData: [],
      disabledDates: {
        from: new Date()
      },

      summaryStartDate: new Date(
        new Date().getTime() - 1000 * 24 * 60 * 60 * 1000
      ),
      summaryEndDate: new Date(),
      summaryStore: [],
      topSellerStartDate: new Date(
        new Date().getTime() - 1000 * 24 * 60 * 60 * 1000
      ),
      topSellerEndDate: new Date(),
      topSellerStore: [],
      topCategoriesStartDate: new Date(
        new Date().getTime() - 1000 * 24 * 60 * 60 * 1000
      ),
      topCategoriesEndDate: new Date(),
      topCategoriesStore: [],
      topSubcategoriesStartDate: new Date(
        new Date().getTime() - 1000 * 24 * 60 * 60 * 1000
      ),
      topSubcategoriesEndDate: new Date(),
      topSubcategoriesStore: [],
      topBrandsStartDate: new Date(
        new Date().getTime() - 1000 * 24 * 60 * 60 * 1000
      ),
      topBrandsEndDate: new Date(),
      topBrandsStore: [],
      salesOverviewStartDate: new Date(
        new Date().getTime() - 1000 * 24 * 60 * 60 * 1000
      ),
      salesOverviewEndDate: new Date(),
      salesOverviewStore: [],
      dailySalesStartDate: new Date(
        new Date().getTime() - 1000 * 24 * 60 * 60 * 1000
      ),
      dailySalesEndDate: new Date(),
      dailySalesStore: [],
      selectedGraph: { title: "Order Count" },
      topSubCategoriesTotalOrderCount: undefined,
      stores: [],
      allStoresArray: [],
      error: undefined,
      showOrderCountGraph: true
    };
  },
  methods: {
    reportOrderSummary(event) {
      if (event && event.type === "change") {
        if (event.target.value) {
          this.summaryStore = [event.target.value];
        } else {
          this.summaryStore = this.allStoresArray;
        }
      }
      const params = {
        startDate: new Date(
          new Date(this.summaryStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.summaryEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.summaryStore
      };
      this.$store
        .dispatch("reportOrderSummary", params)
        .then(result => {
          this.summary = result;
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    reportCityTop(event) {
      if (event && event.type === "change") {
        if (event.target.value) {
          this.salesOverviewStore = [event.target.value];
        } else {
          this.salesOverviewStore = this.allStoresArray;
        }
      }
      const params = {
        startDate: new Date(
          new Date(this.salesOverviewStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.salesOverviewEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.salesOverviewStore
      };
      this.$store
        .dispatch("reportCityTop", params)
        .then(result => {
          this.cityData = result.map(city => [city.city, city.ordersPlaced]);
          this.cityData.unshift(["City", "Orders Placed"]);
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    reportOrderCount(showOrderCountGraph = true, event) {
      if (event && event.type === "change") {
        if (event.target.value) {
          this.dailySalesStore = [event.target.value];
        } else {
          this.dailySalesStore = this.allStoresArray;
        }
      }
      const params = {
        startDate: new Date(
          new Date(this.dailySalesStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.dailySalesEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.dailySalesStore
      };
      this.selectedGraph = {
        title: showOrderCountGraph ? "Order Count" : "Order Value"
      };
      this.$store
        .dispatch("reportOrderCount", params)
        .then(result => {
          if (showOrderCountGraph) {
            this.dailySalesData = result.map(data => [
              `${new Date(data.orderDate).getUTCDate()}-${new Date(
                data.orderDate
              ).getUTCMonth() + 1}-${new Date(
                data.orderDate
              ).getUTCFullYear()}`,
              data.orderCount,
              data.ordersInvoiced
            ]);
            this.dailySalesData.unshift([
              "Date",
              "Orders Placed",
              "Orders Invoiced"
            ]);
          } else {
            this.dailySalesData = result.map(data => [
              `${new Date(data.orderDate).getUTCDate()}-${new Date(
                data.orderDate
              ).getUTCMonth()}-${new Date(data.orderDate).getUTCFullYear()}`,
              data.valueOrdered ? data.valueOrdered : 0,
              data.valueInvoiced ? data.valueInvoiced : 0
            ]);
            this.dailySalesData.unshift([
              "Date",
              "Order Value Placed",
              "Orders Value Billed"
            ]);
          }
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    reportProductsSellingTop(event) {
      if (event && event.type === "change") {
        if (event.target.value) {
          this.topSellerStore = [event.target.value];
        } else {
          this.topSellerStore = this.allStoresArray;
        }
      }
      const params = {
        startDate: new Date(
          new Date(this.topSellerStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.topSellerEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.topSellerStore
      };
      this.$store
        .dispatch("reportProductsSellingTop", params)
        .then(result => {
          this.topSellerData = result;
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    reportCategorySellingTop(event) {
      if (event && event.type === "change") {
        if (event.target.value) {
          this.topCategoriesStore = [event.target.value];
        } else {
          this.topCategoriesStore = this.allStoresArray;
        }
      }
      const params = {
        startDate: new Date(
          new Date(this.topCategoriesStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.topCategoriesEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.topCategoriesStore
      };
      this.$store
        .dispatch("reportCategorySellingTop", params)
        .then(result => {
          this.topCategoriesData = result.map(category => [
            category.categoryName,
            category.numberOfOrders
          ]);
          this.topCategoriesData.unshift(["Quantity", "Category"]);
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    reportSubcategorySellingTop(event) {
      if (event && event.type === "change") {
        if (event.target.value) {
          this.topSubcategoriesStore = [event.target.value];
        } else {
          this.topSubcategoriesStore = this.allStoresArray;
        }
      }
      const params = {
        startDate: new Date(
          new Date(this.topSubcategoriesStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.topSubcategoriesEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.topSubcategoriesStore
      };
      this.$store
        .dispatch("reportSubcategorySellingTop", params)
        .then(result => {
          let initialValue = 0;
          const slicedResults = result.slice(0, 10);
          this.topSubCategoriesTotalOrderCount = slicedResults.reduce(
            (accumulator, currentValue) =>
              accumulator + currentValue.numberOfOrders,
            initialValue
          );
          this.topSubcategoriesData = slicedResults.map(brand => [
            brand.categoryName,
            brand.numberOfOrders
          ]);
          this.topSubcategoriesData.unshift(["Quantity", "Brand"]);
          this.topSubcategoriesData.splice(
            11,
            this.topSubcategoriesData.length
          );
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    reportBrandSellingTop(event) {
      if (event && event.type === "change") {
        if (event.target.value) {
          this.topBrandsStore = [event.target.value];
        } else {
          this.topBrandsStore = this.allStoresArray;
        }
      }
      const params = {
        startDate: new Date(
          new Date(this.topBrandsStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.topBrandsEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.topBrandsStore
      };
      this.$store
        .dispatch("reportBrandSellingTop", params)
        .then(result => {
          this.topBrandsData = result.map(brand => [
            brand.categoryName
              ? brand.categoryName.substring(0, 5) + "..."
              : "",
            brand.numberOfOrders,
            `color:#006296; opacity:${brand.numberOfOrders /
              result[0].numberOfOrders}`
          ]);
          this.topBrandsData.unshift(["Quantity", "Brand", { role: "style" }]);
          this.topBrandsData.splice(11, this.topBrandsData.length);
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    downloadDailySalesCSV() {
      const params = {
        startDate: new Date(
          new Date(this.dailySalesStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.dailySalesEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.dailySalesStore
      };
      const replacer = (key, value) => value;
      const header = [
        { name: "orderDate", value: "orderDate" },
        { name: "ordersPlaced", value: "orderCount" },
        { name: "valueOrdered", value: "valueOrdered" },
        { name: "ordersInvoiced", value: "ordersInvoiced" },
        { name: "valueInvoiced", value: "valueInvoiced" }
      ];
      this.$store
        .dispatch("reportOrderCount", params)
        .then(result => {
          this.$store
            .dispatch("JSONtoCSV", { items: result, header, replacer })
            .then(csv => {
              let a = document.createElement("a");
              a.href = "data:attachment/csv," + encodeURIComponent(csv);
              a.target = "_blank";
              a.download = `dailySalesData.csv`;
              document.body.appendChild(a);
              a.click();
            })
            .catch(err => {
              if (err.status != 401) {
                this.error = err.data;
              } else {
                this.$router.push({ name: "Login" }).catch(() => {});
              }
            });
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    downloadSalesOverviewCSV() {
      const params = {
        startDate: new Date(
          new Date(this.salesOverviewStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.salesOverviewEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.salesOverviewStore
      };
      const replacer = (key, value) => value;
      const header = [
        { name: "city", value: "city" },
        { name: "ordersPlaced", value: "ordersPlaced" },
        { name: "valueOrdered", value: "valueOrdered" },
        { name: "ordersInvoiced", value: "ordersInvoiced" },
        { name: "valueInvoiced", value: "valueInvoiced" }
      ];
      this.$store
        .dispatch("reportCityTop", params)
        .then(result => {
          this.$store
            .dispatch("JSONtoCSV", { items: result, header, replacer })
            .then(csv => {
              let a = document.createElement("a");
              a.href = "data:attachment/csv," + encodeURIComponent(csv);
              a.target = "_blank";
              a.download = `salesOverview.csv`;
              document.body.appendChild(a);
              a.click();
            })
            .catch(err => {
              if (err.status != 401) {
                this.error = err.data;
              } else {
                this.$router.push({ name: "Login" }).catch(() => {});
              }
            });
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    downloadTopCategoriesCSV() {
      const params = {
        startDate: new Date(
          new Date(this.topCategoriesStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.topCategoriesEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.topCategoriesStore
      };
      const replacer = (key, value) => value;
      const header = [
        { name: "categoryName", value: "categoryName" },
        { name: "totalValueOrdered", value: "totalValueUnbilled" },
        { name: "valueBilled", value: "totalValueBilled" },
        { name: "qtyOrdered", value: "numberOfOrders" },
        { name: "qtyBilled", value: "ordersInvoiced" }
      ];
      this.$store
        .dispatch("reportCategorySellingTop", params)
        .then(result => {
          this.$store
            .dispatch("JSONtoCSV", { items: result, header, replacer })
            .then(csv => {
              let a = document.createElement("a");
              a.href = "data:attachment/csv," + encodeURIComponent(csv);
              a.target = "_blank";
              a.download = `topCategories.csv`;
              document.body.appendChild(a);
              a.click();
            })
            .catch(err => {
              if (err.status != 401) {
                this.error = err.data;
              } else {
                this.$router.push({ name: "Login" }).catch(() => {});
              }
            });
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    downloadTopSubcategoriesCSV() {
      const params = {
        startDate: new Date(
          new Date(this.topSubcategoriesStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.topSubcategoriesEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.topSubcategoriesStore
      };
      const replacer = (key, value) => value;
      const header = [
        { name: "subCategoryName", value: "categoryName" },
        { name: "totalValueOrdered", value: "totalValueUnbilled" },
        { name: "valueBilled", value: "totalValueBilled" },
        { name: "qtyOrdered", value: "numberOfOrders" },
        { name: "qtyBilled", value: "ordersInvoiced" }
      ];
      this.$store
        .dispatch("reportSubcategorySellingTop", params)
        .then(result => {
          this.$store
            .dispatch("JSONtoCSV", { items: result, header, replacer })
            .then(csv => {
              let a = document.createElement("a");
              a.href = "data:attachment/csv," + encodeURIComponent(csv);
              a.target = "_blank";
              a.download = `topSubCategories.csv`;
              document.body.appendChild(a);
              a.click();
            })
            .catch(err => {
              if (err.status != 401) {
                this.error = err.data;
              } else {
                this.$router.push({ name: "Login" }).catch(() => {});
              }
            });
        })
        .catch(err => {
          if (err.status !== 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    },
    downloadTopBrandsCSV() {
      const params = {
        startDate: new Date(
          new Date(this.topBrandsStartDate).setHours(0, 0, 0, 0)
        ),
        endDate: new Date(
          new Date(this.topBrandsEndDate).setHours(23, 59, 59, 59)
        ),
        stores: this.topBrandsStore
      };
      const replacer = (key, value) => value;
      const header = [
        { name: "brandName", value: "categoryName" },
        { name: "totalValueOrdered", value: "totalValueUnbilled" },
        { name: "valueBilled", value: "totalValueBilled" },
        { name: "qtyOrdered", value: "numberOfOrders" },
        { name: "qtyBilled", value: "ordersInvoiced" }
      ];
      this.$store
        .dispatch("reportBrandSellingTop", params)
        .then(result => {
          this.$store
            .dispatch("JSONtoCSV", { items: result, header, replacer })
            .then(csv => {
              let a = document.createElement("a");
              a.href = "data:attachment/csv," + encodeURIComponent(csv);
              a.target = "_blank";
              a.download = `topBrandsData.csv`;
              document.body.appendChild(a);
              a.click();
            })
            .catch(err => {
              if (err.status != 401) {
                this.error = err.data;
              } else {
                this.$router.push({ name: "Login" }).catch(() => {});
              }
            });
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" }).catch(() => {});
          }
        });
    }
  }
};
</script>
<style lang="scss">
.home {
  padding: 1rem;
  @media screen and (min-width: 600px) {
    display: grid;
    grid-template-areas: "summary summary summary summary summary summary summary summary top-seller top-seller top-seller top-seller" "daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales top-seller top-seller top-seller top-seller" "daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales top-sub-categories top-sub-categories top-sub-categories top-sub-categories" "daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales daily-sales top-sub-categories top-sub-categories top-sub-categories top-sub-categories" "top-categories top-categories top-categories top-categories top-categories top-categories top-categories top-categories top-sub-categories top-sub-categories top-sub-categories top-sub-categories" "top-categories top-categories top-categories top-categories top-categories top-categories top-categories top-categories top-sub-categories top-sub-categories top-sub-categories top-sub-categories" "top-brands top-brands top-brands top-brands top-brands top-brands top-brands top-brands top-sub-categories top-sub-categories top-sub-categories top-sub-categories" "top-brands top-brands top-brands top-brands top-brands top-brands top-brands top-brands top-sub-categories top-sub-categories top-sub-categories top-sub-categories" "sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview" "sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview sales-overview";
    gap: 1.5rem;
  }
  &__title {
    font-size: 18px;
    font-weight: bold;
    color: #4d4d4d;
    margin-bottom: 0;
    @media screen and (min-width: 600px) {
      display: none;
    }
  }
  &__summary {
    margin-top: 14px;
    @media screen and (min-width: 600px) {
      grid-area: summary;
    }
    &__header {
      display: grid;
      gap: 1rem;
      grid-template-columns: auto 1fr;
      @media screen and (min-width: 600px) {
        grid-template-columns: auto 1fr auto;
      }
      &__title {
        align-self: center;
        font-size: 14px;
        color: #4d4d4d;
        margin-bottom: 0;
        font-weight: bold;
        @media screen and (min-width: 600px) {
          grid-template-columns: repeat(2, 8rem);
          font-size: 16px;
        }
      }
      &__date-picker {
        display: grid;
        gap: 1rem;
        position: relative;
        grid-template-columns: repeat(2, 8rem);
      }
    }
    &__cards {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
      gap: 0.5rem;
      margin-top: 0.75rem;
      &__card {
        padding: 1rem 1.5rem;
        background: #fff;
        &__title {
          font-size: 9px;
          color: #4d4d4d;
          margin-bottom: 0;
        }
        &__value {
          font-size: 18px;
          font-weight: 900;
          color: #4d4d4d;
          margin-bottom: 0;
          @media screen and (min-width: 600px) {
            color: #006296;
          }
        }
      }
    }
  }
  &__daily-sales {
    margin: 0 -1rem;
    padding: 1rem;
    background: #fff;
    margin-top: 1.5rem;
    @media screen and (min-width: 600px) {
      grid-area: daily-sales;
      margin: 0;
    }
    &__graph {
      &__message {
        padding: 5rem 0;
        text-align: center;
      }
    }
    &__header {
      display: grid;
      gap: 1rem;
      @media screen and (min-width: 600px) {
        grid-template-columns: auto 1fr auto auto auto;
      }
      gap: 1rem;
      align-items: center;
      &__date-picker {
        display: grid;
        gap: 1rem;
        position: relative;
        grid-template-columns: repeat(2, 7rem);
        @media screen and (min-width: 600px) {
          grid-template-columns: repeat(2, 8rem);
        }
      }
      &__title {
        font-size: 12.8px;
        font-weight: bold;
        color: #4d4d4d;
        margin-bottom: 0;
        @media screen and (min-width: 600px) {
          font-size: 16px;
        }
      }
      &__download-link {
        font-size: 9.6px;
        color: #006296;
        margin-bottom: 0;
      }
    }
  }
  &__top-seller {
    margin: 0 -1rem;
    padding: 1rem;
    background: #fff;
    margin-top: 0.5rem;
    @media screen and (min-width: 600px) {
      grid-area: top-seller;
      margin: 0;
    }
    &__message {
      padding: 5rem 0;
      text-align: center;
    }
    &__header {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 1rem;
      @media screen and (min-width: 600px) {
        grid-template-columns: auto auto;
      }
      gap: 1rem;
      align-items: center;
      &__date-picker {
        display: grid;
        gap: 1rem;
        position: relative;
        grid-template-columns: repeat(2, 7rem);
        @media screen and (min-width: 600px) {
          grid-template-columns: repeat(2, 8rem);
        }
      }
      &__title {
        font-size: 12.8px;
        font-weight: bold;
        color: #4d4d4d;
        margin-bottom: 0;
        @media screen and (min-width: 600px) {
          font-size: 16px;
        }
      }
    }
    &__item-info {
      padding-left: 1.25rem;
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 4rem;
      margin-top: 1rem;
      &__image {
        max-width: 14rem;
        height: auto;
        width: 100%;
        min-width: 11rem;
      }
      &__features {
        display: grid;
        gap: 1.5rem;
        &__feature {
          &__title {
            font-size: 12px;
            font-weight: 300;
            color: #4d4d4d;
            margin-bottom: 0;
          }
          &__value {
            font-size: 16px;
            font-weight: bold;
            color: #006296;
            margin-bottom: 0;
            word-break: break-word;
          }
        }
      }
    }
  }
  &__top-categories {
    margin: 0 -1rem;
    padding: 1rem;
    background: #fff;
    margin-top: 0.5rem;
    @media screen and (min-width: 600px) {
      grid-area: top-categories;
      margin: 0;
    }
    &__graph {
      &__message {
        padding: 5rem 0;
        text-align: center;
      }
    }
    &__header {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 1rem;
      @media screen and (min-width: 600px) {
        grid-template-columns: auto 1fr auto auto auto;
      }
      gap: 1rem;
      align-items: center;
      &__date-picker {
        display: grid;
        gap: 1rem;
        position: relative;
        grid-template-columns: repeat(2, 7rem);
        @media screen and (min-width: 600px) {
          grid-template-columns: repeat(2, 8rem);
        }
      }
      &__title {
        font-size: 12.8px;
        font-weight: bold;
        color: #4d4d4d;
        margin-bottom: 0;
        @media screen and (min-width: 600px) {
          font-size: 16px;
        }
      }
      &__download-link {
        font-size: 9.6px;
        color: #006296;
        margin-bottom: 0;
      }
    }
  }
  &__top-sub-categories {
    margin: 0 -1rem;
    padding: 1rem;
    background: #fff;
    margin-top: 0.5rem;
    @media screen and (min-width: 600px) {
      grid-area: top-sub-categories;
      margin: 0;
    }
    &__graph {
      display: grid;
      justify-items: center;
      &__values {
        margin: 0 auto;
      }
      &__message {
        padding: 5rem 0;
      }
    }
    &__header {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 1rem;
      justify-items: end;
      @media screen and (min-width: 600px) {
        grid-template-columns: auto auto;
      }
      gap: 1rem;
      align-items: center;
      &__date-picker {
        display: grid;
        gap: 1rem;
        position: relative;
        grid-template-columns: repeat(2, 7rem);
        @media screen and (min-width: 600px) {
          grid-template-columns: repeat(2, 8rem);
        }
      }
      &__title {
        font-size: 12.8px;
        font-weight: bold;
        color: #4d4d4d;
        margin-bottom: 0;
        justify-self: start;
        @media screen and (min-width: 600px) {
          font-size: 16px;
        }
      }
      &__download-link {
        font-size: 9.6px;
        color: #006296;
        margin-bottom: 0;
      }
    }
  }
  &__top-brands {
    margin: 0 -1rem;
    padding: 1rem;
    background: #fff;
    margin-top: 0.5rem;
    @media screen and (min-width: 600px) {
      grid-area: top-brands;
      margin: 0;
    }
    &__graph {
      &__message {
        padding: 5rem 0;
        text-align: center;
      }
    }
    &__header {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 1rem;
      @media screen and (min-width: 600px) {
        grid-template-columns: auto 1fr auto auto auto;
      }
      gap: 1rem;
      align-items: center;
      &__date-picker {
        display: grid;
        gap: 1rem;
        position: relative;
        grid-template-columns: repeat(2, 7rem);
        @media screen and (min-width: 600px) {
          grid-template-columns: repeat(2, 8rem);
        }
      }
      &__title {
        font-size: 12.8px;
        font-weight: bold;
        color: #4d4d4d;
        margin-bottom: 0;
        @media screen and (min-width: 600px) {
          font-size: 16px;
          font-weight: bold;
        }
      }
      &__download-link {
        font-size: 9.6px;
        color: #006296;
        margin-bottom: 0;
      }
    }
  }
  &__sales-overview {
    margin: 0 -1rem;
    padding: 1rem;
    background: #fff;
    margin-top: 0.5rem;
    @media screen and (min-width: 600px) {
      grid-area: sales-overview;
      margin: 0;
    }
    &__header {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 1rem;
      @media screen and (min-width: 600px) {
        grid-template-columns: auto 1fr auto auto auto;
      }
      gap: 1rem;
      align-items: center;
      &__date-picker {
        display: grid;
        gap: 1rem;
        position: relative;
        grid-template-columns: repeat(2, 7rem);
        @media screen and (min-width: 600px) {
          grid-template-columns: repeat(2, 8rem);
        }
      }
      &__title {
        font-size: 12.8px;
        font-weight: bold;
        color: #4d4d4d;
        margin-bottom: 0;
        @media screen and (min-width: 600px) {
          font-size: 16px;
        }
      }
      &__download-link {
        font-size: 9.6px;
        color: #006296;
        margin-bottom: 0;
      }
    }
    &__graph {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 4rem;
      &--hide-xs {
        display: none;
        @media screen and (min-width: 600px) {
          display: block;
        }
      }
      &__message {
        text-align: center;
        padding: 5rem 0;
      }
    }
  }
}
.store-dropdown {
  background: #ffffff;
  border: none;
  color: #4d4d4d;
  background-image: url("data:image/svg+xml;utf8,<svg fill='rgb(77,77,77)' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path id='Path' d='M.213 6.824A.935.935 0 0 1 0 6.228a.906.906 0 0 1 .213-.6L4.773.249a.641.641 0 0 1 1.015 0 .955.955 0 0 1 0 1.2L2.45 5.381s-.5.557-.5.847.5.847.5.847l3.338 3.94a.955.955 0 0 1 0 1.2.641.641 0 0 1-1.015 0z' class='cls-1' transform='rotate(-90 10 5)'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 50%;
  font-size: 14px;
  letter-spacing: 0.44px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  appearance: none;
  border-radius: 3px;
  padding: 10px 25px 10px 10px;
  max-width: 15rem;
  width: 100%;
  &:focus {
    outline: none;
  }
}
.form-control {
  cursor: pointer;
  color: transparent !important;
  text-shadow: 0 0 0 #4d4d4d;
}
.custom-date-input {
  max-width: 7.1rem;
}
</style>
